export default __webpack_public_path__ + "static/media/myportfolio_navicon.d3886ea3.svg";